<template>
  <div>
    <Movementmenu />
    <v-container fluid class="grey lighten-4 pa-6">
      <v-row dense class="mb-4">
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg shadow-sm" color="blue darken-2" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">รายการทั้งหมด</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.total }} <small class="caption">รายการ</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="blue darken-1">
                <v-icon size="30">mdi-clipboard-list-outline</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg shadow-sm" color="red darken-1" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">ขาดเกณฑ์ (ต้องการ)</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.shortage }} <small class="caption">แห่ง</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="red darken-2">
                <v-icon size="30">mdi-account-alert</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg shadow-sm" color="amber darken-2" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">เกินเกณฑ์ (ต้องย้าย)</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.surplus }} <small class="caption">แห่ง</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="amber darken-3">
                <v-icon size="30">mdi-account-multiple-plus</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg shadow-sm" color="green darken-1" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">พอดีเกณฑ์</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.balanced }} <small class="caption">แห่ง</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="green darken-2">
                <v-icon size="30">mdi-check-circle-outline</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <base-material-card
        icon="mdi-format-list-checks"
        title="ข้อมูลอัตรากำลัง ขาด/เกิน ประกอบการพิจารณาย้าย"
        color="success"
        class="px-5 py-3"
      >
        <v-card flat class="grey lighten-5 rounded-lg mb-4 pa-4">
          <v-row align="center">
            <v-col cols="12" md="8" class="d-flex flex-wrap" style="gap: 10px;">
              <v-btn
                small
                rounded
                color="indigo"
                dark
                @click="man_powersummaryCSV()"
              >
                <v-icon left>mdi-file-import</v-icon> นำเข้า CSV
              </v-btn>
              <v-btn
                small
                rounded
                color="success"
                outlined
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> ส่งออก Excel
              </v-btn>
              <v-btn
                small
                rounded
                color="error"
                outlined
                @click="man_powersummaryClear()"
              >
                <v-icon left>mdi-delete-sweep</v-icon> ล้างข้อมูล
              </v-btn>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="ค้นหา (สถานศึกษา, จังหวัด, สถานะ)"
                outlined
                dense
                rounded
                hide-details
                class="bg-white"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>

        <v-data-table
          :headers="headers"
          :items="man_powersummarys"
          :search="search"
          :loading="loading"
          class="elevation-0 custom-table"
        >
          <template v-slot:item.summary_s="{ item }">
            <v-chip
              :color="getStatusColor(item.summary_s)"
              dark
              small
              label
              class="font-weight-bold"
            >
              <v-icon left x-small>{{ getStatusIcon(item.summary_s) }}</v-icon>
              {{ item.summary_s }}
            </v-chip>
          </template>

          <template v-slot:item.total_s="{ item }">
            <span class="font-weight-bold">{{ item.total_s }}</span> อัตรา
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="amber darken-2"
                  @click.stop="man_powersummaryEdit(item.id_no)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>แก้ไขข้อมูล</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </base-material-card>

      <v-dialog
        v-model="editman_powersummarydialog"
        persistent
        max-width="500px"
      >
        <v-card class="rounded-lg">
          <v-toolbar color="amber darken-1" dark flat>
            <v-icon left>mdi-file-edit</v-icon>
            <v-toolbar-title>แก้ไขข้อมูลอัตรากำลัง</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="editman_powersummarydialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-6">
            <div class="subtitle-1 font-weight-bold mb-4 text-center">
              {{ editman_powersummary.college_name }}
            </div>
            <v-form ref="editman_powersummaryform" lazy-validation>
              <v-autocomplete
                v-model="editman_powersummary.summary_s"
                :items="summaryText"
                item-text="text"
                item-value="value"
                label="สถานะสรุปผล"
                outlined
                rounded
                dense
                required
                :rules="[v => !!v || 'กรุณาเลือกสถานะ']"
              ></v-autocomplete>

              <v-text-field
                v-model="editman_powersummary.total_s"
                label="จำนวน (อัตรา)"
                type="number"
                outlined
                rounded
                dense
                required
                :rules="[v => !!v || 'กรุณาระบุจำนวน']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end pa-4 grey lighten-5">
            <v-btn text @click="editman_powersummarydialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="amber darken-2"
              depressed
              dark
              @click="editman_powersummarySubmit"
              >บันทึกการแก้ไข</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="ClearMan_powerdialog" persistent max-width="450px">
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon color="error" class="mr-2">mdi-delete-alert</v-icon>
            ล้างข้อมูลทั้งหมด
          </v-card-title>
          <v-card-text>
            <div class="subtitle-1 error--text font-weight-bold">
              คำเตือน: ข้อมูลอัตรากำลังทั้งหมดจะถูกลบ
            </div>
            <div class="body-2 mt-2">
              ยืนยันที่จะดำเนินการต่อหรือไม่? การกระทำนี้ไม่สามารถกู้คืนได้
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="ClearMan_powerdialog = false">ยกเลิก</v-btn>
            <v-btn color="error" depressed @click="ClearMan_powerSubmit"
              >ยืนยันล้างข้อมูล</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="man_powersummaryCSVdialog"
        persistent
        max-width="500px"
      >
        <v-card class="rounded-lg">
          <v-toolbar color="indigo" dark flat>
            <v-icon left>mdi-file-import</v-icon>
            <v-toolbar-title>นำเข้าไฟล์ CSV</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="man_powersummaryCSVdialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-6">
            <v-btn
              block
              outlined
              color="info"
              class="mb-4"
              to="/admin/man_powersummary_import/"
              target="_blank"
            >
              <v-icon left>mdi-download</v-icon> ดาวน์โหลดแบบฟอร์มตัวอย่าง
            </v-btn>

            <v-file-input
              v-model="file2"
              accept=".csv"
              label="เลือกไฟล์ .csv"
              outlined
              rounded
              dense
              prepend-icon="mdi-paperclip"
              show-size
            ></v-file-input>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="man_powersummaryCSVdialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn color="indigo" depressed dark @click="csvManpowerSubmit"
              >นำเข้าข้อมูล</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        top
        right
        rounded="pill"
      >
        <v-icon left>{{ snackbar.icon }}</v-icon> {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // ต้องติดตั้ง: npm install xlsx

export default {
  components: { Movementmenu },
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      search: "",
      file2: null,

      // Dialog States
      editman_powersummarydialog: false,
      ClearMan_powerdialog: false,
      man_powersummaryCSVdialog: false,

      // Data
      man_powersummarys: [],
      editman_powersummary: {},
      colleges: [],

      snackbar: { show: false, color: "", icon: "", text: "" },

      headers: [
        { text: "สถานศึกษา", align: "left", value: "college_name" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "สถานะสรุปผล", align: "center", value: "summary_s" },
        { text: "จำนวน (อัตรา)", align: "center", value: "total_s" },
        { text: "แก้ไข", align: "center", value: "actions", sortable: false }
      ],

      summaryText: [
        { text: "เกินเกณฑ์ (Surplus)", value: "เกินเกณฑ์" },
        { text: "ขาดเกณฑ์ (Shortage)", value: "ขาดเกณฑ์" },
        { text: "พอดี (Balanced)", value: "พอดี" }
      ],

      data_syslog: {}
    };
  },

  computed: {
    stats() {
      const total = this.man_powersummarys.length;
      const shortage = this.man_powersummarys.filter(
        i => i.summary_s === "ขาดเกณฑ์"
      ).length;
      const surplus = this.man_powersummarys.filter(
        i => i.summary_s === "เกินเกณฑ์"
      ).length;
      const balanced = this.man_powersummarys.filter(
        i => i.summary_s === "พอดี"
      ).length;
      return { total, shortage, surplus, balanced };
    },
    time_stamp() {
      return Date.now();
    },
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return `${dd}/${mm}/${yyyy}/${time}`;
    }
  },

  async mounted() {
    await this.fetchInitialData();
    await this.man_powersummaryQueryAll();
  },

  methods: {
    async fetchInitialData() {
      let res = await this.$http.post("college.php", { ApiKey: this.ApiKey });
      this.colleges = res.data;
    },

    async man_powersummaryQueryAll() {
      this.loading = true;
      try {
        let res = await this.$http.post("man_powersummary.php", {
          ApiKey: this.ApiKey
        });
        this.man_powersummarys = res.data;
      } finally {
        this.loading = false;
      }
    },

    // --- EXCEL EXPORT ---
    exportToExcel() {
      const data = this.man_powersummarys.map(item => ({
        สถานศึกษา: item.college_name,
        จังหวัด: item.province_name,
        สถานะสรุป: item.summary_s,
        จำนวน: item.total_s
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Manpower_Summary");
      XLSX.writeFile(wb, `Manpower_Summary_${this.time_stamp}.xlsx`);
    },

    // --- CSV Import ---
    async man_powersummaryCSV() {
      this.man_powersummaryCSVdialog = true;
    },

    async csvManpowerSubmit() {
      if (this.file2) {
        let formData = new FormData();
        let filename = this.time_stamp + ".manpower.csv";
        formData.append("file", this.file2);
        formData.append("filename", "../HRvecfiles/" + filename);
        formData.append("ApiKey", this.ApiKey);

        let result = await this.$http.post(
          "man_powersummarycsv.php",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (result.data.status == true) {
          this.showSnackbar("นำเข้าข้อมูลเรียบร้อย", "success");
          this.man_powersummaryQueryAll();
          this.man_powersummaryCSVdialog = false;
        } else {
          this.showSnackbar("นำเข้าข้อมูลผิดพลาด", "error");
        }
      }
    },

    // --- Edit Logic ---
    async man_powersummaryEdit(id_no) {
      let result = await this.$http.post("man_powersummary.php", {
        ApiKey: this.ApiKey,
        id_no: id_no
      });
      this.editman_powersummary = result.data;
      this.editman_powersummarydialog = true;
    },

    async editman_powersummarySubmit() {
      if (this.$refs.editman_powersummaryform.validate()) {
        this.editman_powersummary.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "man_powersummary.update.php",
          this.editman_powersummary
        );

        if (result.data.status == true) {
          this.showSnackbar("แก้ไขข้อมูลเรียบร้อย", "success");
          this.logSystem(
            "update",
            `${this.editman_powersummary.id_summary_s}:${this.editman_powersummary.college_code}`
          );
          this.man_powersummaryQueryAll();
          this.editman_powersummarydialog = false;
        } else {
          this.showSnackbar("แก้ไขข้อมูลผิดพลาด", "error");
        }
      }
    },

    // --- Clear Data Logic ---
    async man_powersummaryClear() {
      this.ClearMan_powerdialog = true;
    },

    async ClearMan_powerSubmit() {
      let payload = { ApiKey: this.ApiKey };
      let result = await this.$http.post("man_powersummary.clear.php", payload);

      if (result.data.status == true) {
        this.showSnackbar("ล้างข้อมูลเรียบร้อย", "success");
        this.logSystem("Clear", "All Summary Data");
        this.man_powersummaryQueryAll();
        this.ClearMan_powerdialog = false;
      } else {
        this.showSnackbar("ล้างข้อมูลผิดพลาด", "error");
      }
    },

    // --- Helpers ---
    getStatusColor(status) {
      if (status === "ขาดเกณฑ์") return "red";
      if (status === "เกินเกณฑ์") return "amber darken-2";
      if (status === "พอดี") return "green";
      return "grey";
    },
    getStatusIcon(status) {
      if (status === "ขาดเกณฑ์") return "mdi-arrow-down-bold";
      if (status === "เกินเกณฑ์") return "mdi-arrow-up-bold";
      return "mdi-check";
    },

    async logSystem(event, detail) {
      let userSession = JSON.parse(sessionStorage.getItem("user")) || {};
      this.data_syslog = {
        ApiKey: this.ApiKey,
        user_account: userSession.user_name || "unknown",
        event_log: event,
        page_log: "man_powersummary",
        table_log: "man_powersummary",
        detail_log: detail,
        date_times: this.date_today_log
      };
      await this.$http.post("data_syslog.insert.php", this.data_syslog);
    },

    showSnackbar(text, color) {
      this.snackbar = {
        show: true,
        text,
        color,
        icon: color === "success" ? "mdi-check-circle" : "mdi-alert"
      };
    }
  }
};
</script>

<style scoped>
.custom-table >>> thead th {
  font-weight: 600 !important;
  color: #333 !important;
  background-color: #f8f9fa;
}
.shadow-sm {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}
.bg-white {
  background-color: white;
}
</style>
